export default function HeroCard9() {
  return (
    <>
       <section className="edu2-hero">

        {/* FLOATING PARTICLES */}
        <div className="p p1"></div>
        <div className="p p2"></div>
        <div className="p p3"></div>
        <div className="p p4"></div>

        {/* OPACITY GLOW CIRCLES */}
        <div className="oc-c9 oc-c91"></div>
        <div className="oc-c9 oc-c92"></div>
        <div className="oc-c9 oc-c93"></div>
        <div className="oc-c9 oc-c94"></div>
        <div className="oc-c9 oc-c95"></div>

        {/* RADIAL BG CIRCLE */}
        <div className="edu2-circle-c9"></div>

        {/* MAIN GRID */}
        <div className="edu2-container ">

          {/* LEFT SIDE */}
          <div className="edu2-left fadeUp ">
            <p className="welcome">Welcome</p>

            <h1 className="edu2-title">
              Providing <br />
              Best Education <br />
              For Brighter future
            </h1>

            <p className="edu2-desc">
              All the Lorem Ipsum generators on the Internet tend to repeat
              predefined chunks as necessary.
            </p>

            <button className="edu2-btn">Join Now</button>
          </div>

          {/* RIGHT SIDE – PHOTO CARDS */}
          <div className="edu2-right ">
 <div className="p p1"></div>
        <div className="p p2"></div>
        <div className="p p3"></div>
        <div className="p p4"></div>

            {/* Top-left rectangle */}
            <div className="card-c9-circle-c9 ringGlow card-c91 float-c9 shine-c9">
              <img src="https://i.postimg.cc/fb0Gq22L/cheerful-student-posing-against-pink-wall-with-glasses.jpg" />
            </div>

            {/* Top-right circle-c9 */}
            <div className="card-c9-circle-c9 ringGlow float-c9Delay shine-c9">
              <img src="https://i.postimg.cc/g2v3W5z5/red-haired-lady-eyeglasses-holds-books-shows-ok-sign.jpg" />
            </div>

            {/* Middle rectangle */}
            <div className="card-c9-circle-c9 ringGlow card-c92 float-c9Slow shine-c9">
              <img src="https://i.postimg.cc/G24xxVq7/smiling-pensive-brunette-schoolgirl-with-long-hair-hugging-book.jpg" />
            </div>

            {/* Bottom-right rectangle with pattern */}
            <div className="card-c9-circle-c9 ringGlow  float-c9Delay2 shine-c9">
             
              <img src="https://i.postimg.cc/NjR1gXDD/young_tender_curly_girl_holding_doc-c9uments_removebg_preview.png" />
            </div>

          </div>

        </div>
      </section>

      <style>{`
/* ------------------------------------------------------ */
/* BASE HERO */
/* ------------------------------------------------------ */
.edu2-hero {
  background: #3b0e6f;
  padding: 120px 0;
  position: relative;
  overflow: hidden;
  color: #fff;
  font-family: Inter, sans-serif;
}

/* MAIN CONTAINER */
.edu2-container {
  width: 90%;
  max-width: 1300px;
  margin: auto;
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  align-items: center;
  gap: 40px;
}

/* LEFT */
.welcome {
  font-size: 22px;
  margin-bottom: 10px;
  position: relative;
}
.welcome::after {
  content: "";
  position: absolute;
  width: 60px;
  height: 3px;
  background: #ff78d6;
  left: 95px;
  top: 14px;
  opacity: .8;
}

.edu2-title {
  font-size: 54px;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 20px;
}

.edu2-desc {
  width: 80%;
  font-size: 17px;
  opacity: .85;
  margin-bottom: 35px;
}

.edu2-btn {
  background: #ff509e;
  border: none;
  padding: 14px 38px;
  border-radius: 10px;
  font-size: 18px;
  cursor: pointer;
  color: #fff;
  transition: 0.3s;
}
.edu2-btn:hover {
  transform: translateY(-5px);
  background: #ff63b5;
}

/* ------------------------------------------------------ */
/* RIGHT SIDE CARDS */
/* ------------------------------------------------------ */
.edu2-right {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2,1fr);
  gap: 25px;
}

/* BASE CARD STYLE */
.card-c9 {
  border-radius: 28px;
  overflow: hidden;
  position: relative;
  background: #ffb3d1;
  box-shadow: 0 20px 40px rgba(0,0,0,0.25);
}

.card-c9 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* CIRCLE CARD */
.card-c9-circle-c9 {
  width: 200px;height:200px;
 background:linear-gradient(
    120deg,
    transparent 0%,
    rgba(255,255,255,0.35) 45%,
    rgba(255,255,255,0.7) 50%,
    rgba(255,255,255,0.35) 55%,
    transparent 100%
  );
  border-radius: 50%;padding:10px;
  overflow: hidden;
  position: relative;
}
.card-c9-circle-c9 img { position:absolute;top:0px;left:0px;right:0px;bottom:0px;
  width: 100%;  border-radius: 10%;
}

/* PATTERN CARD */
.card-c9-pattern {
  background: #deaaff;
  position: relative;
}
.pattern {
  position: absolute;
  width: 100%;
  height: 100%;
  background: url("https://i.postimg.cc/h4qvz20M/lines.png");
  opacity: 0.25;
  z-index: 0;
}

/* ------------------------------------------------------ */
/* GLOW RING BEHIND CIRCLE */
/* ------------------------------------------------------ */
.ringGlow::after {
  content: "";
  position: absolute;

  
  inset: -20px;
  border-radius: 50%;
  background: radial-gradient(circle-c9, #ff7be06e, transparent 70%);
  z-index: -1;
  filter: blur(50px);
}

/* ------------------------------------------------------ */
/* GRADIENT SHINE SWEEP */
/* ------------------------------------------------------ */
.shine-c9::before {
  content: "";
  position: absolute;
  top: -100%;
  left: -150%;
  width: 300%;
  height: 300%;
  background: linear-gradient(
    120deg,
    transparent 0%,
    rgba(255,255,255,0.35) 45%,
    rgba(255,255,255,0.7) 50%,
    rgba(255,255,255,0.35) 55%,
    transparent 100%
  );
  transform: translateX(-100%);
  transition: transform 0.8s ease;
  pointer-events: none;
}
.shine-c9:hover::before {
  transform: translateX(100%);
}

/* ------------------------------------------------------ */
/* OPACITY CIRCLES */
/* ------------------------------------------------------ */
.oc-c9 {
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(
    circle-c9,
    rgba(255,255,255,0.10),
    rgba(255,255,255,0.03),
    transparent 70%
  );
  filter: blur(4px);
  pointer-events: none;
}

.oc-c91 { width: 260px; height: 260px; left: 40px; top: 140px; }
.oc-c92 { width: 180px; height: 180px; left: 180px; top: 300px; opacity:.5; }
.oc-c93 { width: 220px; height: 220px; right: 150px; top: 180px; }
.oc-c94 { width: 350px; height: 350px; right: 20px; bottom: 40px; opacity:.35; }
.oc-c95 {
  width: 160px;
  height: 160px;
  left: 65%;
  top: 60%;
  opacity:.3;
  animation: oc-c9Pulse 4s infinite ease-in-out;
}
@keyframes oc-c9Pulse {
  0% { transform: scale(1); opacity:.25; }
  50% { transform: scale(1.15); opacity:.45; }
  100% { transform: scale(1); opacity:.25; }
}

/* ------------------------------------------------------ */
/* RADIAL BACKGROUND */
/* ------------------------------------------------------ */
.edu2-circle-c9 {
  position: absolute;z-index:99;
  width: 900px;
  height: 900px;
  background: radial-gradient(circle, #ece5f3ff, #e3ddebff 70%);
  border-radius: 50%;
  left: -300px;
  top: -200px;
  opacity: .1;
}

/* ------------------------------------------------------ */
/* FLOAT ANIMATIONS */
/* ------------------------------------------------------ */
.float-c9 { animation: float-c9Anim 4s ease-in-out infinite; }
.float-c9Slow { animation: float-c9Anim 6s ease-in-out infinite; }
.float-c9Delay { animation: float-c9Anim 4.5s ease-in-out infinite; right:40px;}
.float-c9Delay2 { animation: float-c9Anim 5.2s ease-in-out infinite;right:-40px; }

@keyframes float-c9Anim {
  0% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
  100% { transform: translateY(0); }
}

/* FADE UP */
.fadeUp {
  opacity: 0;
  animation: fUp .8s ease forwards;
}
@keyframes fUp {
  from { opacity:0; transform: translateY(20px); }
  to { opacity:1; transform: translateY(0); }
}

/* ------------------------------------------------------ */
/* PARTICLES */
/* ------------------------------------------------------ */
.p {
  position: absolute;
  background: #ffffff44;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  animation: particle 6s infinite linear;
}
.p1 { top: 20%; left: 10%; animation-delay: 0s; }
.p2 { top: 40%; left: 4%; animation-delay: 1s; }
.p3 { bottom: 30%; left: 8%; animation-delay: 2s; }
.p4 { bottom: 20%; left: 15%; animation-delay: 3s; }

@keyframes particle {
  0% { transform: translateY(0px); opacity:.4; }
  50% { transform: translateY(-20px); opacity:.8; }
  100% { transform: translateY(0px); opacity:.4; }
}

/* ------------------------------------------------------ */
/* RESPONSIVE */
/* ------------------------------------------------------ */
@media (max-width: 900px) {
  .edu2-container {
    grid-template-columns: 1fr;
    text-align: center;
  }
  .edu2-right {
    margin-top: 60px;
  }
  .edu2-desc {
    width: 100%;
  }
}
      `}</style>
    </>
  );
}
